<script>import { browser } from "$app/environment";
const prodHosts = ["rocketbet.com", "www.rocketbet.com", "prod-rocketbet.previewenv.net"];
const showSeal = browser && prodHosts.includes(window.location.hostname);
</script>

{#if showSeal}
	<iframe
		title="Seal"
		src="/seal-rocket.htm"
		style="height: 50px; width: 50px; border: none; display: block;"
	></iframe>
{/if}
